import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'

const slice = createSlice({
  name: 'common/popup/sessionExpired',
  initialState: {
    isShow: false,
  },
  reducers: {
    changeIsShow: (state, action) => {
      state.isShow = action.payload
    },
  },
})

export const selectIsShow = (state) => state[slice.name].isShow
export const { changeIsShow } = slice.actions

register(slice.name, slice.reducer)
